/* @flow */
import React from 'react'

import './style.css'

const Divider = (props) => {
  const style = {
    width: props.width && props.width,
    height: props.height && props.height,
    backgroundColor: props.color && props.color
  }
  return (
    <div className={"divider " + (props.className && props.className)} style={style}></div>
  )
}

export default Divider


// WEBPACK FOOTER //
// ./src/components/Divider/index.js